// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> axia-residential-arc-living-preferred -> novo-sweetwater
// Generated: 2026-10-01T17:22:53.987Z
// Counts: 3 design, 82 content, 27 slot group, 4 collection binding, 9 section, 12 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.color.hyperlink": {
    "cssVariable": "--vibe-color-hyperlink",
    "overrideType": "VALUE",
    "value": "#00306b",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Voted 2026 Best Apartment Community in Lithia Springs</h2><h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to NOVO Sweetwater in Lithia Springs, GA, where spacious one, two, and three-bedroom floor plans harmonize with vibrant community life. Enjoy proximity to enriching and entertaining spots, like the South Cobb Regional Library, Sweetwater Creek State Park, and Six Flags, ensuring both relaxation and adventure are right at your doorstep. Embrace a lifestyle that inspires!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibilitystatement.heading": {
    "overrideType": "VALUE",
    "customValue": " ",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibilitystatement.intro": {
    "overrideType": "VALUE",
    "customValue": "<p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-map.config_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_repli_id"
  },
  "applynowactions.show_application_block": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "callrail-tracking.account_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_account_hash"
  },
  "callrail-tracking.company_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_company_id"
  },
  "contactus.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height_mobile": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "iframe-embed.height": {
    "overrideType": "VALUE",
    "customValue": "2000",
    "generatedValue": null,
    "mappedField": null
  },
  "iframe-embed.url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "preferredemployerprogram.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Exclusive Apartment Offers for Employees in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.source": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.scheduler_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "scheduleatour.show_tour_scheduler": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.height": {
    "overrideType": "VALUE",
    "customValue": "1400",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019df440-5a5c-711f-a5a7-1aa3a99b22ab.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Our luxury apartments in Lithia Springs, GA, have a pool, fitness center, and lush green spaces. With modern finishes like <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/virtual-tour\">granite counters and garden tubs</a>, your new home at NOVO Sweetwater is designed for relaxation and style. Embrace the life you deserve!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At NOVO Sweetwater, we offer <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">spacious floor plans</a> designed to suit every lifestyle, from cozy one-bedroom retreats to expansive three-bedroom homes. Each residence blends comfort and modern elegance. Curious about the availability of our rentals in Lithia Springs, GA? Reach out to our leasing team today—your dream apartment awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At NOVO Sweetwater, your ideal home awaits! Choose from our diverse range of one, two, and three-bedroom apartments in Lithia Springs, GA, with a washer and dryer, perfectly designed to fit your lifestyle. Browse our available apartment homes and <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/amenities\">amenities</a> today, and let your journey to comfort and style begin!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At NOVO Sweetwater, life unfolds amid luxurious <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/amenities\">amenities</a> and <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">stunning floor plans.</a> Imagine soaking up the sun by the resort-style pool or unwinding in your stylish three-bedroom haven. With beautifully landscaped courtyards, top-notch fitness facilities, and easy access to Thornton Road shopping, you'll be able to picture yourself living in the vibrant community of your dreams!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>NOVO Sweetwater offers more than just stunning <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">one, two, and three-bedroom floor plans</a>. Our apartments are located near downtown Douglasville and WellStar Douglas Hospital in Lithia Springs.  Enjoy the convenience of other nearby major employers and attractions, like Sweetwater Creek State Park, the Douglas County Museum of History and Art, and Falcon Stadium. Uncover your vibrant new lifestyle today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to NOVO Sweetwater, where your furry friends are part of the family! Our pet-friendly <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">apartments</a> in Lithia Springs, GA, include a dog park. With ample space for two pets and an accessible pet policy, your home is just as cozy for them as it is for you. Embrace a vibrant lifestyle that truly accommodates everyone.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerprogram.employers_list": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>Delta Airlines</p></li><li><p>The Defax Center</p></li><li><p>Publix</p></li><li><p>Medical Personnel</p></li><li><p>School System Employees</p></li><li><p>Police Departments</p></li><li><p>Veterans or Military Personnel</p></li><li><p>Fire Department</p></li><li><p>Amazon Warehouse</p></li><li><p>Chick-fil-A</p></li><li><p>Postal Workers</p></li><li><p>The Home Depot</p></li><li><p>Coca-Cola Consolidated</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to NOVO Sweetwater, the premier apartment community nestled in the heart of Lithia Springs, GA. Offering a variety of spacious floor plans, choose from our stylish <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">one, two, or three-bedroom apartments </a>designed with your comfort in mind. Each residence showcases luxurious features such as stainless steel appliances, 42\" shaker-style cabinetry, granite countertops, and garden tubs that transform everyday living into an extraordinary experience. At NOVO Sweetwater, we believe in delivering a lifestyle that balances luxury, convenience, and community. Residents can unwind in our <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/amenities\">resort-inspired swimming pool</a>, complete with a sun deck, or take advantage of our state-of-the-art fitness center boasting free weights and modern workout equipment. Gather with friends in our resident social lounge or cozy up by the outdoor fireplace lounge, all while warming up to the beautiful landscaped courtyards and green spaces that make our lively community feel like home. You’ll appreciate the ease of on-site leasing and management teams, as well as our dedicated service team, ready to assist with your needs. Enjoy the convenience of controlled access, garages, and a centralized mail hub. <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/pet-policy\">Pet owners</a> will adore our PupPlay Park, while car enthusiasts can pamper their vehicles at our AutoSpa. Experience the blend of comfort and luxury living at NOVO Sweetwater. Don’t miss the opportunity to <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/virtual-tour\">discover your new home today</a>—browse our availability or schedule a tour to explore our community!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to NOVO Sweetwater in Lithia Springs, GA! Our <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">versatile floor plans</a> feature one, two, and three-bedroom apartments tailored to your lifestyle. Access your resident portal today to effortlessly pay rent, schedule maintenance, and manage all your housing needs in one convenient place. Experience modern living at its finest!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At NOVO Sweetwater, find your ideal space among our thoughtfully designed <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">one, two, and three-bedroom</a> Lithia Springs, GA rentals. Experience the perfect blend of comfort and community—schedule a tour today and hear firsthand from residents who call this vibrant community home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the charm of NOVO Sweetwater! With thoughtfully designed <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">one, two, and three-bedroom apartments</a> near Atlanta, GA, your perfect home awaits. Step inside and envision your future—take a virtual tour of our community and floor plans, and see why NOVO Sweetwater is your ideal destination!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "_template:hyperlocal::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-97f3-7639-b260-de47af5e925b.webp"
      }
    }
  },
  "featuring/apartment-with-pool-monroe-30655::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c4-10ad-70df-9602-86bb71aa6152.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a modern apartment building with a parking lot in front."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": 124,
    "fieldOverrides": null
  },
  "ctasection.card2_image": {
    "sourceIndex": 19,
    "fieldOverrides": null
  },
  "ctasection.card3_image": {
    "sourceIndex": 130,
    "fieldOverrides": null
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-81b3-740d-a7bd-9495dce1ec3b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room and kitchen area of a modern apartment with a blue sofa, accent chair, and stainless steel appliances."
      }
    }
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-627f-765b-ba97-6abddc04a28c.webp"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c3-f726-7478-b027-1b8a520b8217.webp"
      }
    }
  },
  "floorplanslist.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d3-d935-7167-af7b-2ae311d906b7.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-7d67-7179-b22a-d7b650adf134.webp"
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c4-3f23-75e8-9f54-14b971a85828.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor seating area with a fire pit and string lights at dusk."
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": ""
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "featuring/fitness-center-apartments-douglas-county::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-97f3-7639-b260-de47af5e925b.webp"
      }
    }
  },
  "featuring/resort-style-pool-apartments-lithia-springs::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-97f3-7639-b260-de47af5e925b.webp"
      }
    }
  },
  "neighborhoodcallout.image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[23].poi_featured_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[23].poi_featured_image_media.alt_text"
      }
    }
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[15].poi_featured_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[15].poi_featured_image_media.alt_text"
      }
    }
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c2-f438-746e-8ca3-fe1730ec2846.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "People enjoying a backyard barbecue with string lights and colorful flags overhead."
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-5328-754d-ab7b-fad25997db6a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with agility equipment and surrounding trees."
      }
    }
  },
  "scheduleatourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-d1a2-73bd-ad40-95cc065a497d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Clubhouse lounge area with seating, tables, and art."
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-7b22-76a9-9ad2-2d79a41da2d6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with island seating and open living area."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": [
      "custom_abd5dc14-a73a-4a36-835a-d127967954c0"
    ],
    "orderedIds": [
      "custom_259d19e4-442e-469f-971f-411793bc1307",
      "custom_e12ae288-5a50-4247-be05-5ba3647b1718",
      "custom_af39a900-02cc-4570-a79c-ab4b84a5eee5",
      "custom_690a9bbd-8c72-4dbb-8187-c9bce080c940",
      "custom_2ccb66c6-9300-4090-94f2-765b669da336",
      "custom_bc62d996-ff78-4c19-ab82-395c3381cd55",
      "custom_3534a202-9299-409a-8fbc-b81b250f95fa",
      "custom_cc212aaa-9062-49f5-be3d-78b163c1eb18",
      "custom_9cad0bcd-a98e-4f90-9049-b863a4e16fb4",
      "custom_caaa2e68-569d-40d8-9885-19e919004c6c",
      "custom_8b076ad9-6582-4217-ab5e-3bfe775afb9a",
      "custom_3871e5d8-0551-4694-aada-9d5e5208e9d3",
      "custom_abd5dc14-a73a-4a36-835a-d127967954c0",
      "custom_526402fe-bde5-492f-b31a-aab843b4cc42",
      "custom_3f0e9f49-d9a5-46e5-8006-a8cf176fa6d3",
      "custom_602dafbb-293b-4724-ba1c-2e2fbc2b831b",
      "custom_d95c66dc-072f-47ad-b431-7f828cadaf0f",
      "custom_2533df2e-6bb2-49dd-b457-1545a929b12e",
      "custom_e6b02933-d5c7-49ba-9587-375d079cde70",
      "custom_b4894e6e-0584-4fd8-8277-5e170e8433f7",
      "custom_c2eaf582-68aa-4ff4-807a-939aefa1692f",
      "custom_abd77020-4c17-4855-9665-03f5605e4dc8",
      "custom_732c974b-b5c7-4e2e-a4a1-ecb5bbf31d27",
      "custom_b262cfab-e8ff-4268-9bc3-57cb7327a60d",
      "custom_1f424e1b-5061-48fa-9e51-6d7f4b3e0b89",
      "custom_3bf43ce0-be14-4276-a6e9-3071006d422c",
      "custom_bef87a02-3d6b-478c-bb4d-515da1161a02",
      "custom_cd18e09e-cca4-48ff-ad70-58f519b90c32",
      "custom_ec13f72d-5220-4b33-9ef9-cd2200af486b",
      "custom_5d49442e-fcc6-4dbe-8102-0feb8435346d",
      "custom_c18b8be2-52f9-407e-89e7-54c7bfe4adf2",
      "custom_742083e4-8290-4d7a-a6c4-4660bdc8f48b",
      "custom_88639ebb-e30c-40ad-b759-d19ce4e88450",
      "custom_a04205d7-7757-466d-93f5-59ca6dbed76e",
      "custom_9a0bb140-2228-4fee-b31d-1a409531d7d2",
      "custom_de39f2f3-4cfa-4ed7-ad0a-1b80ea950b9b",
      "custom_51d99147-0f37-4397-8254-33aea4d51524",
      "custom_35d32b8e-1157-45ca-b027-dfcb9ca867c8",
      "custom_59c15027-71f9-4abc-837d-4b8903f9e148",
      "custom_486f7c29-43b6-421f-824f-7ed0e6dc3182",
      "custom_8b82a6ae-78db-4373-9b0a-6abf9e788cd8",
      "custom_7b85360a-112a-44d3-bf72-f66de12b0f1a",
      "custom_fde72ffc-92c7-4b03-8683-3575b7840b1a",
      "custom_cb84f77c-960b-463b-a299-84cc0f3874c8",
      "custom_75852bf7-78e8-4a88-bd7b-d4234cdb83f0",
      "custom_80813580-dfc4-4eec-be19-7445a60bc74a",
      "custom_0e7c117d-2bd3-4dda-a6a4-1bbfa8e5caa3",
      "custom_64e39f6a-7821-4d4d-ab37-8de0ca73c048",
      "custom_dd4f4300-7562-45c1-a588-010611609ae3",
      "custom_09ae7879-0e00-431a-805b-461de5898503",
      "custom_a6b17538-0b10-4624-bd2f-46bbc0799bf2",
      "custom_01ed121b-b408-42b3-b232-cb294918bb9b",
      "custom_15666036-d6b0-401d-8881-a6034f2c91ba",
      "custom_8e95334c-e0b5-49e5-ac17-c4aac40a130f",
      "custom_f38676ac-3419-494a-96d9-a54c5379982c",
      "custom_bb5f1a1c-f805-43df-9566-92ee275961ed",
      "custom_f8af57d7-2b3b-445b-a1e2-7e1671ad094e",
      "custom_931632d9-4e8d-401e-b8e2-ffb19460b3d1",
      "custom_8b4133c2-9a72-4535-9628-4ab647134393",
      "custom_b3e01491-8e4e-4ab3-a31a-3526b4ccce9d",
      "custom_9b3e1ee2-ba7c-4830-be51-990c8d241415",
      "custom_1002aa7b-4d48-48a5-90c7-3b6beff690d9",
      "custom_e8fd0813-3099-408a-986c-55ebf54a9905",
      "custom_3d9923d8-897d-45e4-bd43-5044b0788fbb",
      "custom_7b0e686a-7266-4e72-a1e8-eeed4ee6efda",
      "custom_8a49cd48-0797-40e9-ad64-294fb1f22a97",
      "custom_b57717d9-7155-464d-9991-9ce567ecd365",
      "custom_b93d152e-728b-4ed2-9ee7-b8c13bbe07f7",
      "custom_6363df25-e480-4e0f-8355-3b02a99e9538",
      "custom_d15287ed-fff6-47bd-a60d-ca5036153f08",
      "custom_e309b43e-a575-429c-b363-3cb37ef07ede",
      "custom_a37a8bbf-a5ce-471d-8584-27d603a967ce",
      "custom_7c218968-d8c1-4ba7-bd2d-ab76768f3679",
      "custom_861b8f5f-a372-4263-9b78-855100ba5057",
      "custom_664c132e-1c19-4d84-b811-d349dbae5ef0",
      "custom_9cffe15c-2100-4592-9c00-eb06695ab2bd",
      "custom_11de0551-12a6-4b39-bfd9-7bb8c41c556c",
      "custom_4b82a4b5-7881-43d2-9a60-ef8c0f053afd",
      "custom_76c3649c-59b0-4e11-93fc-08a988305f13",
      "custom_2a8d409e-99b4-445e-ba10-e952b6da25cf",
      "custom_4cb36f03-f2ac-4b6d-8aaa-c9228b5e6b36",
      "custom_e69c51a0-a728-453d-9607-6a1d3f834d54",
      "custom_9e4efe1d-8cf8-4e57-ae26-59999659a6c2",
      "custom_baf104d3-4c60-4eed-9c13-5a18d6252d40",
      "custom_3c6bb6b7-6af8-4164-acef-47630f2a04db",
      "custom_1a1d93e1-67b0-4c72-b173-8078d5bb7eea",
      "custom_0ec7387f-3c8c-4eaa-bf57-668a3d6df497",
      "custom_935d9ac6-eebd-4cee-9ad8-f03525a4703f",
      "custom_1760220e-ded5-4030-9593-b1ec788e8cc2",
      "custom_f791f178-562b-4ee5-82a5-67304fec93bc",
      "custom_dd6a448e-41ce-41ed-8161-0805cd9fdf16",
      "custom_3bbc867b-abea-4613-b2f4-b9430c7549dd",
      "custom_7c09928b-6ac7-4237-933b-59a9c6d9926c",
      "custom_3bf8a2c9-67d6-4f8c-8e42-706a4dd43409",
      "custom_2bfff0b6-6fda-4dcb-bcb2-42a15a674bc4",
      "custom_17574c2d-4b30-4e05-aa01-dd18084d1ca4",
      "custom_244bf803-9454-435a-8ac7-c06c4dbd1519",
      "custom_37261e66-c4c4-45fe-8714-fdd4ba0ef61d",
      "custom_7ee9e464-6b10-453d-8a6a-6a77a5c188a5",
      "custom_18714700-dfdd-41c9-9c4e-5ee7d15b585a",
      "custom_ce4a1e99-b827-4ac0-86c3-4effc2f698dc",
      "custom_824ebc41-cf2e-4943-8953-098a9c88754c",
      "custom_eccfe922-84a2-466e-a2d6-88516c863225",
      "custom_f115f733-be9c-464b-adeb-6bc7035793e2",
      "custom_374b3bc6-fdcb-4520-997b-b8c575f91a6c",
      "custom_1b8b908f-6115-4f6f-b4f5-d1a1ebc53882",
      "custom_da2d13bb-48d8-47db-8e58-25b4183b3c05",
      "custom_0b1c90e2-0a2c-4b8b-9602-71850ee6b191",
      "custom_c9c94362-9b51-4e85-b173-64198bd63cd0",
      "custom_116cd627-bd7f-49df-b324-e52a4cad9862",
      "custom_957345c1-df3a-478a-b4cc-9ef0e0184674",
      "custom_73884718-929e-4f06-a0f9-2ee1a9038840",
      "custom_8d3fb8fa-d91e-4cab-ab34-6e8fd6bf5aed",
      "custom_21bad2de-c1cf-4ab7-9747-db897c38a5be",
      "custom_486e3655-b16b-4c1d-a3c5-630f6e582a25",
      "custom_a2af8887-a2e3-4edb-9b2c-a4dd167a3808",
      "custom_fd9fe44e-8645-4b19-8162-a283cfa8b820",
      "custom_edaabef7-27d6-4e3f-a4bf-eecde25b14cc",
      "custom_8f1f9994-95a5-42b2-9d73-b596a97fdcd7",
      "custom_ad2d9184-427b-42b0-afb8-1d09d026aab9",
      "custom_adddadd4-fe11-4ca9-acca-1928c358a56c",
      "custom_7fe1efb5-e84c-474f-b433-5f02fa54001d",
      "custom_e7058465-c637-4d98-b81c-bc1e378e1852",
      "custom_531c7d85-6082-46a1-ba5b-57d7f4565db2",
      "custom_f614107d-253b-447c-bce5-336ff8af9ec2",
      "custom_62a27f14-3618-48fe-9bdf-d504417c11d5",
      "custom_b7a5dd13-3f1a-4721-9db8-3753167873ea",
      "custom_80ec4e13-d1e7-472a-8f59-b1e7efa75c6d",
      "custom_c327bf67-3beb-4b95-b156-1b44fd0c03b5",
      "custom_d0b96db8-b18c-4bc1-a279-1d3bb31a22e7",
      "custom_b29f955f-aa2b-4202-8d84-6ed4daf7e5ff",
      "custom_55313cee-3ac7-42a0-8ee1-53dac40d540d",
      "custom_800a5f14-e71e-46a7-b21a-553758b43013",
      "custom_99c5753b-7b80-4cb3-98b5-d15623346270",
      "custom_7c3be744-8a5f-42ec-b214-0dc08ccb4614",
      "custom_94961423-1784-4e49-a46b-5be36589ff87",
      "custom_d4e23efe-1241-42cc-8aab-42a04357cd3d",
      "custom_6b7040fd-6e0e-49af-84fb-ba9136f96a36",
      "custom_423fd1b4-d2e9-4533-a40f-0eb1a7886bee",
      "custom_b0c9b538-51ee-49cd-9964-1b255da99e3c",
      "custom_39380562-4e32-4cd7-98a9-4825aa0a83ca",
      "custom_3bec9f16-8c63-4b07-be7f-d1684be326e3",
      "custom_b32499a4-d647-40d4-9684-945c5c8cfe0f",
      "custom_901df861-43ec-4a54-b2cd-b72302443cd5",
      "custom_216f3995-678e-4b18-8171-5b10563798e7",
      "custom_4b4a89db-e6bf-4070-9d2e-f61630bf5e0f",
      "custom_4b004a69-aa46-4210-9daa-a272667e4e59",
      "custom_a06e95f2-33af-43cf-8ec6-5fdfaa8f63a0",
      "custom_1177a76a-d103-4d8e-ba56-2f9426d5d74f",
      "custom_63ca6b55-10cf-496f-a9eb-628c48c53451",
      "custom_b652e0a7-860b-4c1b-871b-12507567705f",
      "custom_a9439d52-8e46-4c2d-bc91-2b7a48e41136",
      "custom_7dd56b71-6031-4cb7-97ec-2e68ec1a95ec",
      "custom_e9b624dd-6d86-4761-8e41-c4f04ab2ef75",
      "custom_e1b49c91-3ff6-4ed5-9046-071212a2ef5d",
      "custom_4340890a-8ef9-491b-8950-a6b4dc3ce587",
      "custom_b41b79cb-1e79-4f7d-aad4-83a6e4cead9f",
      "custom_6b8f7523-ce1c-4316-b326-923378293771",
      "custom_a8ffb98e-32bb-4346-977b-397137eed2e0",
      "custom_6c04348a-53dd-430b-a774-31a4dda78793",
      "custom_193907f1-0694-4008-9edb-39be1e1d3377",
      "custom_c1e9cc28-b371-4eb0-b375-a3a177e42fca",
      "custom_68e0dcbc-31ea-47f8-b96e-375a1553d0fc",
      "custom_2d410e30-70a0-4ec3-a64d-884c9b01ac4b",
      "custom_aecfdc47-47c9-4543-b974-b28c711f2c50",
      "custom_c323a04c-05cd-4f80-a12e-29a1e185de4a",
      "custom_ad6fc557-db86-475d-a6e9-9afd6e752dd2",
      "custom_fa821b18-b398-48f9-a1fc-0b9b34b66a66",
      "custom_2ff14cba-de6e-4077-9802-ac8f25b57ea7",
      "custom_c77591fc-491a-46e4-a9fb-675217980d0e",
      "custom_63378e52-236c-453c-856d-660686518156",
      "custom_81274761-0f12-4df1-8fdb-23af56f31196",
      "custom_e061342d-548d-4ce5-9d19-61e6e796c4ce",
      "custom_8f40fb88-3990-469e-8edb-1b7e7828073f",
      "custom_5c9252fc-651b-4f81-8bb3-69d536ba493c",
      "custom_daba147e-3bcc-4af3-924b-096fe6a7c909",
      "custom_7f7b5582-84d9-4e3d-aa5b-bc5457d18a21",
      "custom_47e8eeeb-867c-4127-a3c1-fc9dfba12d18",
      "custom_d820bd06-a9ad-455c-975f-2bb1c5657210",
      "custom_63f0d513-57a8-4a69-8976-904491cda417",
      "custom_a1a18e59-10b3-4a1b-bf12-780ed1be9a70",
      "custom_72d57dc6-bbdd-407a-aa58-b985ab52f022",
      "custom_bc01f1ed-f4dc-46cc-8aa2-264e5cae6a4e",
      "custom_de9792ac-2a13-4c18-aef2-0bfb609b6ee0",
      "custom_6403ebfb-b72f-47f8-8cd4-55340a2e836a",
      "custom_9407f82a-e352-476b-8c7d-eb4d9f91ea21",
      "custom_5496d9cc-5e69-48d7-99a1-50d1fa5ba25b",
      "custom_62faf0ed-b03b-4211-99ec-e171994e8b83",
      "custom_8b4da7d4-09e6-467a-899c-3a4bd62460d2",
      "custom_417aa98c-4b16-4667-ad7e-a7849280b638",
      "custom_b3925021-b54c-4c4a-a7ea-2e9894d1dd3b",
      "custom_0bc31b9b-ba93-499d-8675-8db10b3e721c",
      "custom_edec1609-009f-4463-86b0-accc41ec04fa",
      "custom_6ee76f01-ad75-4d83-bd80-6bda6e049ed5",
      "custom_a62af7bf-c222-4eca-bf5e-c3e38de2d062",
      "custom_b46ea962-e47a-4f1d-9281-8b2d0e011767",
      "custom_0664bfff-26a5-4d5f-9013-31235cc87569",
      "custom_bed6a7a6-468c-4fb7-8e06-1414d2c05d36",
      "custom_c2a0377b-257a-4c46-9330-2936389e9543",
      "custom_c2906e56-ae4e-441d-8660-9a9cf6d8f5bd",
      "custom_a4cef0c0-b898-4f42-8dff-367b7f1502ca",
      "custom_f622756b-e6ca-410f-82ed-432e2128f1ea",
      "custom_01037c61-f6e7-41f5-a503-e2de8d9cffcb",
      "custom_51d7e86c-fe57-49e8-a03b-4274eb2d72d4",
      "custom_42b18d10-be25-4d42-8424-d8ffa693b83b",
      "custom_23669b57-89f5-4c86-a3cc-32519e9b2c48",
      "custom_94d0c7c0-a9eb-48fa-9a2f-e781fc65b055",
      "custom_4e53780d-5917-451e-b907-6efe5a526141",
      "custom_6fb5993c-771d-4ca1-b36d-e4a94d798b73",
      "custom_a19589fe-a593-4185-80b2-a98077ac9bb5",
      "custom_4c37e943-b2fb-4314-9d0e-149850e15e04",
      "custom_b723a628-3700-4d97-9532-fb8360984ae1",
      "custom_c9c2d50c-66f6-4009-b949-7b17368e58a0",
      "custom_20a67c23-1414-44c6-bc88-a3c7a82577b1",
      "custom_67b81763-b803-45ff-b676-0c0d2c0944d6",
      "custom_c8babe89-5c88-4adf-b9a2-3eda36be6413",
      "custom_7c236a13-44f4-499e-a903-cd9350d669df",
      "custom_ce0d8e5a-f104-4831-971e-070752a7e73a",
      "custom_a1d2f373-f87a-400d-be92-8914d2296070",
      "custom_c7f68e0a-1841-4bf1-bcd2-94d97d27cc8f",
      "custom_102df797-0cde-4dcb-95fb-c15b46b17b39",
      "custom_58864869-e508-461a-8113-6cee0efad918",
      "custom_31259d83-e9b2-407c-8064-82afe905076e",
      "custom_083eb8b5-ea94-49ea-a1c0-8a9801419e8e",
      "custom_fcfe58d2-f17d-4ea5-8e07-8fb490083173",
      "custom_b1ea0426-413c-423c-b94a-4b058790d3e5"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_fcfe58d2-f17d-4ea5-8e07-8fb490083173",
      "custom_c9c2d50c-66f6-4009-b949-7b17368e58a0",
      "custom_901df861-43ec-4a54-b2cd-b72302443cd5",
      "custom_216f3995-678e-4b18-8171-5b10563798e7",
      "custom_4b004a69-aa46-4210-9daa-a272667e4e59",
      "custom_4b4a89db-e6bf-4070-9d2e-f61630bf5e0f",
      "custom_b32499a4-d647-40d4-9684-945c5c8cfe0f",
      "custom_3bec9f16-8c63-4b07-be7f-d1684be326e3",
      "custom_39380562-4e32-4cd7-98a9-4825aa0a83ca",
      "custom_b0c9b538-51ee-49cd-9964-1b255da99e3c",
      "custom_423fd1b4-d2e9-4533-a40f-0eb1a7886bee",
      "custom_6b7040fd-6e0e-49af-84fb-ba9136f96a36",
      "custom_94961423-1784-4e49-a46b-5be36589ff87",
      "custom_d4e23efe-1241-42cc-8aab-42a04357cd3d",
      "custom_7c3be744-8a5f-42ec-b214-0dc08ccb4614",
      "custom_7fe1efb5-e84c-474f-b433-5f02fa54001d",
      "custom_adddadd4-fe11-4ca9-acca-1928c358a56c",
      "custom_ad2d9184-427b-42b0-afb8-1d09d026aab9",
      "custom_8f1f9994-95a5-42b2-9d73-b596a97fdcd7",
      "custom_edaabef7-27d6-4e3f-a4bf-eecde25b14cc",
      "custom_fd9fe44e-8645-4b19-8162-a283cfa8b820",
      "custom_a2af8887-a2e3-4edb-9b2c-a4dd167a3808",
      "custom_486e3655-b16b-4c1d-a3c5-630f6e582a25",
      "custom_21bad2de-c1cf-4ab7-9747-db897c38a5be",
      "custom_8d3fb8fa-d91e-4cab-ab34-6e8fd6bf5aed",
      "custom_73884718-929e-4f06-a0f9-2ee1a9038840",
      "custom_957345c1-df3a-478a-b4cc-9ef0e0184674",
      "custom_116cd627-bd7f-49df-b324-e52a4cad9862",
      "custom_c9c94362-9b51-4e85-b173-64198bd63cd0",
      "custom_0b1c90e2-0a2c-4b8b-9602-71850ee6b191",
      "custom_da2d13bb-48d8-47db-8e58-25b4183b3c05",
      "custom_1b8b908f-6115-4f6f-b4f5-d1a1ebc53882",
      "custom_f115f733-be9c-464b-adeb-6bc7035793e2",
      "custom_eccfe922-84a2-466e-a2d6-88516c863225",
      "custom_824ebc41-cf2e-4943-8953-098a9c88754c",
      "custom_ce4a1e99-b827-4ac0-86c3-4effc2f698dc",
      "custom_18714700-dfdd-41c9-9c4e-5ee7d15b585a",
      "custom_7ee9e464-6b10-453d-8a6a-6a77a5c188a5",
      "custom_37261e66-c4c4-45fe-8714-fdd4ba0ef61d",
      "custom_244bf803-9454-435a-8ac7-c06c4dbd1519",
      "custom_17574c2d-4b30-4e05-aa01-dd18084d1ca4",
      "custom_2bfff0b6-6fda-4dcb-bcb2-42a15a674bc4",
      "custom_3bf8a2c9-67d6-4f8c-8e42-706a4dd43409",
      "custom_7c09928b-6ac7-4237-933b-59a9c6d9926c",
      "custom_3bbc867b-abea-4613-b2f4-b9430c7549dd",
      "custom_dd6a448e-41ce-41ed-8161-0805cd9fdf16",
      "custom_f791f178-562b-4ee5-82a5-67304fec93bc",
      "custom_1760220e-ded5-4030-9593-b1ec788e8cc2",
      "custom_935d9ac6-eebd-4cee-9ad8-f03525a4703f",
      "custom_0ec7387f-3c8c-4eaa-bf57-668a3d6df497",
      "custom_1a1d93e1-67b0-4c72-b173-8078d5bb7eea",
      "custom_3c6bb6b7-6af8-4164-acef-47630f2a04db",
      "custom_baf104d3-4c60-4eed-9c13-5a18d6252d40",
      "custom_9e4efe1d-8cf8-4e57-ae26-59999659a6c2",
      "custom_4cb36f03-f2ac-4b6d-8aaa-c9228b5e6b36",
      "custom_e69c51a0-a728-453d-9607-6a1d3f834d54",
      "custom_76c3649c-59b0-4e11-93fc-08a988305f13",
      "custom_75852bf7-78e8-4a88-bd7b-d4234cdb83f0",
      "custom_80813580-dfc4-4eec-be19-7445a60bc74a",
      "custom_64e39f6a-7821-4d4d-ab37-8de0ca73c048",
      "custom_7b85360a-112a-44d3-bf72-f66de12b0f1a",
      "custom_8b82a6ae-78db-4373-9b0a-6abf9e788cd8",
      "custom_486f7c29-43b6-421f-824f-7ed0e6dc3182",
      "custom_59c15027-71f9-4abc-837d-4b8903f9e148",
      "custom_35d32b8e-1157-45ca-b027-dfcb9ca867c8",
      "custom_51d99147-0f37-4397-8254-33aea4d51524",
      "custom_de39f2f3-4cfa-4ed7-ad0a-1b80ea950b9b",
      "custom_9a0bb140-2228-4fee-b31d-1a409531d7d2",
      "custom_a04205d7-7757-466d-93f5-59ca6dbed76e",
      "custom_88639ebb-e30c-40ad-b759-d19ce4e88450",
      "custom_742083e4-8290-4d7a-a6c4-4660bdc8f48b",
      "custom_c18b8be2-52f9-407e-89e7-54c7bfe4adf2",
      "custom_5d49442e-fcc6-4dbe-8102-0feb8435346d",
      "custom_ec13f72d-5220-4b33-9ef9-cd2200af486b",
      "custom_cd18e09e-cca4-48ff-ad70-58f519b90c32",
      "custom_bef87a02-3d6b-478c-bb4d-515da1161a02",
      "custom_3bf43ce0-be14-4276-a6e9-3071006d422c",
      "custom_1f424e1b-5061-48fa-9e51-6d7f4b3e0b89",
      "custom_b262cfab-e8ff-4268-9bc3-57cb7327a60d",
      "custom_732c974b-b5c7-4e2e-a4a1-ecb5bbf31d27",
      "custom_abd77020-4c17-4855-9665-03f5605e4dc8",
      "custom_c2eaf582-68aa-4ff4-807a-939aefa1692f",
      "custom_b4894e6e-0584-4fd8-8277-5e170e8433f7",
      "custom_e6b02933-d5c7-49ba-9587-375d079cde70",
      "custom_2533df2e-6bb2-49dd-b457-1545a929b12e",
      "custom_b1ea0426-413c-423c-b94a-4b058790d3e5",
      "custom_083eb8b5-ea94-49ea-a1c0-8a9801419e8e",
      "custom_31259d83-e9b2-407c-8064-82afe905076e",
      "custom_58864869-e508-461a-8113-6cee0efad918",
      "custom_102df797-0cde-4dcb-95fb-c15b46b17b39",
      "custom_c7f68e0a-1841-4bf1-bcd2-94d97d27cc8f",
      "custom_a1d2f373-f87a-400d-be92-8914d2296070",
      "custom_ce0d8e5a-f104-4831-971e-070752a7e73a",
      "custom_7c236a13-44f4-499e-a903-cd9350d669df",
      "custom_c8babe89-5c88-4adf-b9a2-3eda36be6413",
      "custom_67b81763-b803-45ff-b676-0c0d2c0944d6",
      "custom_20a67c23-1414-44c6-bc88-a3c7a82577b1",
      "custom_b723a628-3700-4d97-9532-fb8360984ae1",
      "custom_4c37e943-b2fb-4314-9d0e-149850e15e04",
      "custom_6fb5993c-771d-4ca1-b36d-e4a94d798b73",
      "custom_a19589fe-a593-4185-80b2-a98077ac9bb5",
      "custom_4e53780d-5917-451e-b907-6efe5a526141",
      "custom_23669b57-89f5-4c86-a3cc-32519e9b2c48",
      "custom_94d0c7c0-a9eb-48fa-9a2f-e781fc65b055",
      "custom_42b18d10-be25-4d42-8424-d8ffa693b83b",
      "custom_51d7e86c-fe57-49e8-a03b-4274eb2d72d4",
      "custom_b652e0a7-860b-4c1b-871b-12507567705f",
      "custom_a9439d52-8e46-4c2d-bc91-2b7a48e41136",
      "custom_7dd56b71-6031-4cb7-97ec-2e68ec1a95ec",
      "custom_e9b624dd-6d86-4761-8e41-c4f04ab2ef75",
      "custom_e1b49c91-3ff6-4ed5-9046-071212a2ef5d",
      "custom_4340890a-8ef9-491b-8950-a6b4dc3ce587",
      "custom_0bc31b9b-ba93-499d-8675-8db10b3e721c",
      "custom_edec1609-009f-4463-86b0-accc41ec04fa",
      "custom_6ee76f01-ad75-4d83-bd80-6bda6e049ed5",
      "custom_a62af7bf-c222-4eca-bf5e-c3e38de2d062",
      "custom_b46ea962-e47a-4f1d-9281-8b2d0e011767",
      "custom_0664bfff-26a5-4d5f-9013-31235cc87569",
      "custom_bed6a7a6-468c-4fb7-8e06-1414d2c05d36",
      "custom_abd5dc14-a73a-4a36-835a-d127967954c0"
    ],
    "orderedIds": [
      "custom_259d19e4-442e-469f-971f-411793bc1307",
      "custom_e12ae288-5a50-4247-be05-5ba3647b1718",
      "custom_af39a900-02cc-4570-a79c-ab4b84a5eee5",
      "custom_690a9bbd-8c72-4dbb-8187-c9bce080c940",
      "custom_2ccb66c6-9300-4090-94f2-765b669da336",
      "custom_bc62d996-ff78-4c19-ab82-395c3381cd55",
      "custom_3534a202-9299-409a-8fbc-b81b250f95fa",
      "custom_cc212aaa-9062-49f5-be3d-78b163c1eb18",
      "custom_9cad0bcd-a98e-4f90-9049-b863a4e16fb4",
      "custom_caaa2e68-569d-40d8-9885-19e919004c6c",
      "custom_8b076ad9-6582-4217-ab5e-3bfe775afb9a",
      "custom_3871e5d8-0551-4694-aada-9d5e5208e9d3",
      "custom_526402fe-bde5-492f-b31a-aab843b4cc42",
      "custom_3f0e9f49-d9a5-46e5-8006-a8cf176fa6d3",
      "custom_602dafbb-293b-4724-ba1c-2e2fbc2b831b",
      "custom_d95c66dc-072f-47ad-b431-7f828cadaf0f",
      "custom_2533df2e-6bb2-49dd-b457-1545a929b12e",
      "custom_abd5dc14-a73a-4a36-835a-d127967954c0",
      "custom_e6b02933-d5c7-49ba-9587-375d079cde70",
      "custom_b4894e6e-0584-4fd8-8277-5e170e8433f7",
      "custom_c2eaf582-68aa-4ff4-807a-939aefa1692f",
      "custom_abd77020-4c17-4855-9665-03f5605e4dc8",
      "custom_732c974b-b5c7-4e2e-a4a1-ecb5bbf31d27",
      "custom_b262cfab-e8ff-4268-9bc3-57cb7327a60d",
      "custom_1f424e1b-5061-48fa-9e51-6d7f4b3e0b89",
      "custom_3bf43ce0-be14-4276-a6e9-3071006d422c",
      "custom_bef87a02-3d6b-478c-bb4d-515da1161a02",
      "custom_cd18e09e-cca4-48ff-ad70-58f519b90c32",
      "custom_ec13f72d-5220-4b33-9ef9-cd2200af486b",
      "custom_5d49442e-fcc6-4dbe-8102-0feb8435346d",
      "custom_c18b8be2-52f9-407e-89e7-54c7bfe4adf2",
      "custom_742083e4-8290-4d7a-a6c4-4660bdc8f48b",
      "custom_88639ebb-e30c-40ad-b759-d19ce4e88450",
      "custom_a04205d7-7757-466d-93f5-59ca6dbed76e",
      "custom_9a0bb140-2228-4fee-b31d-1a409531d7d2",
      "custom_de39f2f3-4cfa-4ed7-ad0a-1b80ea950b9b",
      "custom_51d99147-0f37-4397-8254-33aea4d51524",
      "custom_35d32b8e-1157-45ca-b027-dfcb9ca867c8",
      "custom_59c15027-71f9-4abc-837d-4b8903f9e148",
      "custom_486f7c29-43b6-421f-824f-7ed0e6dc3182",
      "custom_8b82a6ae-78db-4373-9b0a-6abf9e788cd8",
      "custom_7b85360a-112a-44d3-bf72-f66de12b0f1a",
      "custom_fde72ffc-92c7-4b03-8683-3575b7840b1a",
      "custom_cb84f77c-960b-463b-a299-84cc0f3874c8",
      "custom_75852bf7-78e8-4a88-bd7b-d4234cdb83f0",
      "custom_80813580-dfc4-4eec-be19-7445a60bc74a",
      "custom_0e7c117d-2bd3-4dda-a6a4-1bbfa8e5caa3",
      "custom_64e39f6a-7821-4d4d-ab37-8de0ca73c048",
      "custom_dd4f4300-7562-45c1-a588-010611609ae3",
      "custom_09ae7879-0e00-431a-805b-461de5898503",
      "custom_a6b17538-0b10-4624-bd2f-46bbc0799bf2",
      "custom_01ed121b-b408-42b3-b232-cb294918bb9b",
      "custom_15666036-d6b0-401d-8881-a6034f2c91ba",
      "custom_8e95334c-e0b5-49e5-ac17-c4aac40a130f",
      "custom_f38676ac-3419-494a-96d9-a54c5379982c",
      "custom_bb5f1a1c-f805-43df-9566-92ee275961ed",
      "custom_f8af57d7-2b3b-445b-a1e2-7e1671ad094e",
      "custom_931632d9-4e8d-401e-b8e2-ffb19460b3d1",
      "custom_8b4133c2-9a72-4535-9628-4ab647134393",
      "custom_b3e01491-8e4e-4ab3-a31a-3526b4ccce9d",
      "custom_9b3e1ee2-ba7c-4830-be51-990c8d241415",
      "custom_1002aa7b-4d48-48a5-90c7-3b6beff690d9",
      "custom_e8fd0813-3099-408a-986c-55ebf54a9905",
      "custom_3d9923d8-897d-45e4-bd43-5044b0788fbb",
      "custom_7b0e686a-7266-4e72-a1e8-eeed4ee6efda",
      "custom_8a49cd48-0797-40e9-ad64-294fb1f22a97",
      "custom_b57717d9-7155-464d-9991-9ce567ecd365",
      "custom_b93d152e-728b-4ed2-9ee7-b8c13bbe07f7",
      "custom_6363df25-e480-4e0f-8355-3b02a99e9538",
      "custom_d15287ed-fff6-47bd-a60d-ca5036153f08",
      "custom_e309b43e-a575-429c-b363-3cb37ef07ede",
      "custom_a37a8bbf-a5ce-471d-8584-27d603a967ce",
      "custom_7c218968-d8c1-4ba7-bd2d-ab76768f3679",
      "custom_861b8f5f-a372-4263-9b78-855100ba5057",
      "custom_664c132e-1c19-4d84-b811-d349dbae5ef0",
      "custom_9cffe15c-2100-4592-9c00-eb06695ab2bd",
      "custom_11de0551-12a6-4b39-bfd9-7bb8c41c556c",
      "custom_4b82a4b5-7881-43d2-9a60-ef8c0f053afd",
      "custom_76c3649c-59b0-4e11-93fc-08a988305f13",
      "custom_2a8d409e-99b4-445e-ba10-e952b6da25cf",
      "custom_4cb36f03-f2ac-4b6d-8aaa-c9228b5e6b36",
      "custom_e69c51a0-a728-453d-9607-6a1d3f834d54",
      "custom_9e4efe1d-8cf8-4e57-ae26-59999659a6c2",
      "custom_baf104d3-4c60-4eed-9c13-5a18d6252d40",
      "custom_3c6bb6b7-6af8-4164-acef-47630f2a04db",
      "custom_1a1d93e1-67b0-4c72-b173-8078d5bb7eea",
      "custom_0ec7387f-3c8c-4eaa-bf57-668a3d6df497",
      "custom_935d9ac6-eebd-4cee-9ad8-f03525a4703f",
      "custom_1760220e-ded5-4030-9593-b1ec788e8cc2",
      "custom_f791f178-562b-4ee5-82a5-67304fec93bc",
      "custom_dd6a448e-41ce-41ed-8161-0805cd9fdf16",
      "custom_3bbc867b-abea-4613-b2f4-b9430c7549dd",
      "custom_7c09928b-6ac7-4237-933b-59a9c6d9926c",
      "custom_3bf8a2c9-67d6-4f8c-8e42-706a4dd43409",
      "custom_2bfff0b6-6fda-4dcb-bcb2-42a15a674bc4",
      "custom_17574c2d-4b30-4e05-aa01-dd18084d1ca4",
      "custom_244bf803-9454-435a-8ac7-c06c4dbd1519",
      "custom_37261e66-c4c4-45fe-8714-fdd4ba0ef61d",
      "custom_7ee9e464-6b10-453d-8a6a-6a77a5c188a5",
      "custom_18714700-dfdd-41c9-9c4e-5ee7d15b585a",
      "custom_ce4a1e99-b827-4ac0-86c3-4effc2f698dc",
      "custom_824ebc41-cf2e-4943-8953-098a9c88754c",
      "custom_eccfe922-84a2-466e-a2d6-88516c863225",
      "custom_f115f733-be9c-464b-adeb-6bc7035793e2",
      "custom_374b3bc6-fdcb-4520-997b-b8c575f91a6c",
      "custom_1b8b908f-6115-4f6f-b4f5-d1a1ebc53882",
      "custom_da2d13bb-48d8-47db-8e58-25b4183b3c05",
      "custom_0b1c90e2-0a2c-4b8b-9602-71850ee6b191",
      "custom_c9c94362-9b51-4e85-b173-64198bd63cd0",
      "custom_116cd627-bd7f-49df-b324-e52a4cad9862",
      "custom_957345c1-df3a-478a-b4cc-9ef0e0184674",
      "custom_73884718-929e-4f06-a0f9-2ee1a9038840",
      "custom_8d3fb8fa-d91e-4cab-ab34-6e8fd6bf5aed",
      "custom_21bad2de-c1cf-4ab7-9747-db897c38a5be",
      "custom_486e3655-b16b-4c1d-a3c5-630f6e582a25",
      "custom_a2af8887-a2e3-4edb-9b2c-a4dd167a3808",
      "custom_fd9fe44e-8645-4b19-8162-a283cfa8b820",
      "custom_edaabef7-27d6-4e3f-a4bf-eecde25b14cc",
      "custom_8f1f9994-95a5-42b2-9d73-b596a97fdcd7",
      "custom_ad2d9184-427b-42b0-afb8-1d09d026aab9",
      "custom_adddadd4-fe11-4ca9-acca-1928c358a56c",
      "custom_7fe1efb5-e84c-474f-b433-5f02fa54001d",
      "custom_e7058465-c637-4d98-b81c-bc1e378e1852",
      "custom_531c7d85-6082-46a1-ba5b-57d7f4565db2",
      "custom_f614107d-253b-447c-bce5-336ff8af9ec2",
      "custom_62a27f14-3618-48fe-9bdf-d504417c11d5",
      "custom_b7a5dd13-3f1a-4721-9db8-3753167873ea",
      "custom_80ec4e13-d1e7-472a-8f59-b1e7efa75c6d",
      "custom_c327bf67-3beb-4b95-b156-1b44fd0c03b5",
      "custom_d0b96db8-b18c-4bc1-a279-1d3bb31a22e7",
      "custom_b29f955f-aa2b-4202-8d84-6ed4daf7e5ff",
      "custom_55313cee-3ac7-42a0-8ee1-53dac40d540d",
      "custom_800a5f14-e71e-46a7-b21a-553758b43013",
      "custom_99c5753b-7b80-4cb3-98b5-d15623346270",
      "custom_7c3be744-8a5f-42ec-b214-0dc08ccb4614",
      "custom_94961423-1784-4e49-a46b-5be36589ff87",
      "custom_d4e23efe-1241-42cc-8aab-42a04357cd3d",
      "custom_6b7040fd-6e0e-49af-84fb-ba9136f96a36",
      "custom_423fd1b4-d2e9-4533-a40f-0eb1a7886bee",
      "custom_b0c9b538-51ee-49cd-9964-1b255da99e3c",
      "custom_39380562-4e32-4cd7-98a9-4825aa0a83ca",
      "custom_3bec9f16-8c63-4b07-be7f-d1684be326e3",
      "custom_b32499a4-d647-40d4-9684-945c5c8cfe0f",
      "custom_901df861-43ec-4a54-b2cd-b72302443cd5",
      "custom_216f3995-678e-4b18-8171-5b10563798e7",
      "custom_4b4a89db-e6bf-4070-9d2e-f61630bf5e0f",
      "custom_4b004a69-aa46-4210-9daa-a272667e4e59",
      "custom_a06e95f2-33af-43cf-8ec6-5fdfaa8f63a0",
      "custom_1177a76a-d103-4d8e-ba56-2f9426d5d74f",
      "custom_63ca6b55-10cf-496f-a9eb-628c48c53451",
      "custom_b652e0a7-860b-4c1b-871b-12507567705f",
      "custom_a9439d52-8e46-4c2d-bc91-2b7a48e41136",
      "custom_7dd56b71-6031-4cb7-97ec-2e68ec1a95ec",
      "custom_e9b624dd-6d86-4761-8e41-c4f04ab2ef75",
      "custom_e1b49c91-3ff6-4ed5-9046-071212a2ef5d",
      "custom_4340890a-8ef9-491b-8950-a6b4dc3ce587",
      "custom_b41b79cb-1e79-4f7d-aad4-83a6e4cead9f",
      "custom_6b8f7523-ce1c-4316-b326-923378293771",
      "custom_a8ffb98e-32bb-4346-977b-397137eed2e0",
      "custom_6c04348a-53dd-430b-a774-31a4dda78793",
      "custom_193907f1-0694-4008-9edb-39be1e1d3377",
      "custom_c1e9cc28-b371-4eb0-b375-a3a177e42fca",
      "custom_68e0dcbc-31ea-47f8-b96e-375a1553d0fc",
      "custom_2d410e30-70a0-4ec3-a64d-884c9b01ac4b",
      "custom_aecfdc47-47c9-4543-b974-b28c711f2c50",
      "custom_c323a04c-05cd-4f80-a12e-29a1e185de4a",
      "custom_ad6fc557-db86-475d-a6e9-9afd6e752dd2",
      "custom_fa821b18-b398-48f9-a1fc-0b9b34b66a66",
      "custom_2ff14cba-de6e-4077-9802-ac8f25b57ea7",
      "custom_c77591fc-491a-46e4-a9fb-675217980d0e",
      "custom_63378e52-236c-453c-856d-660686518156",
      "custom_81274761-0f12-4df1-8fdb-23af56f31196",
      "custom_e061342d-548d-4ce5-9d19-61e6e796c4ce",
      "custom_8f40fb88-3990-469e-8edb-1b7e7828073f",
      "custom_5c9252fc-651b-4f81-8bb3-69d536ba493c",
      "custom_daba147e-3bcc-4af3-924b-096fe6a7c909",
      "custom_7f7b5582-84d9-4e3d-aa5b-bc5457d18a21",
      "custom_47e8eeeb-867c-4127-a3c1-fc9dfba12d18",
      "custom_d820bd06-a9ad-455c-975f-2bb1c5657210",
      "custom_63f0d513-57a8-4a69-8976-904491cda417",
      "custom_a1a18e59-10b3-4a1b-bf12-780ed1be9a70",
      "custom_72d57dc6-bbdd-407a-aa58-b985ab52f022",
      "custom_bc01f1ed-f4dc-46cc-8aa2-264e5cae6a4e",
      "custom_de9792ac-2a13-4c18-aef2-0bfb609b6ee0",
      "custom_6403ebfb-b72f-47f8-8cd4-55340a2e836a",
      "custom_9407f82a-e352-476b-8c7d-eb4d9f91ea21",
      "custom_5496d9cc-5e69-48d7-99a1-50d1fa5ba25b",
      "custom_62faf0ed-b03b-4211-99ec-e171994e8b83",
      "custom_8b4da7d4-09e6-467a-899c-3a4bd62460d2",
      "custom_417aa98c-4b16-4667-ad7e-a7849280b638",
      "custom_b3925021-b54c-4c4a-a7ea-2e9894d1dd3b",
      "custom_0bc31b9b-ba93-499d-8675-8db10b3e721c",
      "custom_edec1609-009f-4463-86b0-accc41ec04fa",
      "custom_6ee76f01-ad75-4d83-bd80-6bda6e049ed5",
      "custom_a62af7bf-c222-4eca-bf5e-c3e38de2d062",
      "custom_b46ea962-e47a-4f1d-9281-8b2d0e011767",
      "custom_0664bfff-26a5-4d5f-9013-31235cc87569",
      "custom_bed6a7a6-468c-4fb7-8e06-1414d2c05d36",
      "custom_c2a0377b-257a-4c46-9330-2936389e9543",
      "custom_c2906e56-ae4e-441d-8660-9a9cf6d8f5bd",
      "custom_a4cef0c0-b898-4f42-8dff-367b7f1502ca",
      "custom_f622756b-e6ca-410f-82ed-432e2128f1ea",
      "custom_01037c61-f6e7-41f5-a503-e2de8d9cffcb",
      "custom_51d7e86c-fe57-49e8-a03b-4274eb2d72d4",
      "custom_42b18d10-be25-4d42-8424-d8ffa693b83b",
      "custom_23669b57-89f5-4c86-a3cc-32519e9b2c48",
      "custom_94d0c7c0-a9eb-48fa-9a2f-e781fc65b055",
      "custom_4e53780d-5917-451e-b907-6efe5a526141",
      "custom_6fb5993c-771d-4ca1-b36d-e4a94d798b73",
      "custom_a19589fe-a593-4185-80b2-a98077ac9bb5",
      "custom_4c37e943-b2fb-4314-9d0e-149850e15e04",
      "custom_b723a628-3700-4d97-9532-fb8360984ae1",
      "custom_c9c2d50c-66f6-4009-b949-7b17368e58a0",
      "custom_20a67c23-1414-44c6-bc88-a3c7a82577b1",
      "custom_67b81763-b803-45ff-b676-0c0d2c0944d6",
      "custom_c8babe89-5c88-4adf-b9a2-3eda36be6413",
      "custom_7c236a13-44f4-499e-a903-cd9350d669df",
      "custom_ce0d8e5a-f104-4831-971e-070752a7e73a",
      "custom_a1d2f373-f87a-400d-be92-8914d2296070",
      "custom_c7f68e0a-1841-4bf1-bcd2-94d97d27cc8f",
      "custom_102df797-0cde-4dcb-95fb-c15b46b17b39",
      "custom_58864869-e508-461a-8113-6cee0efad918",
      "custom_31259d83-e9b2-407c-8064-82afe905076e",
      "custom_083eb8b5-ea94-49ea-a1c0-8a9801419e8e",
      "custom_fcfe58d2-f17d-4ea5-8e07-8fb490083173",
      "custom_b1ea0426-413c-423c-b94a-4b058790d3e5"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "callrail-tracking",
      "blockId": "callrail-tracking",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 8
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 9,
      "gridSpanMobile": 12
    }
  ],
  "schedule-a-tour": [
    {
      "sectionId": "elise-schedule-tour-iframe",
      "blockId": "elise-schedule-tour-iframe",
      "position": 8
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "_section.block:iframe-embed": {
    "properties": {
      "overflow": "hidden"
    }
  },
  "amenities-blurb.text": {
    "properties": {
      "--vibe-color-hyperlink": "#1a0dab"
    }
  },
  "contact-blurb.text": {
    "properties": {
      "--vibe-color-hyperlink": "#1a0dab"
    }
  },
  "floor-plans-blurb.text": {
    "properties": {
      "--vibe-color-hyperlink": "#1a0dab"
    }
  },
  "gallery-blurb.text": {
    "properties": {
      "--vibe-color-hyperlink": "#1a0dab"
    }
  },
  "neighborhood-blurb.text": {
    "properties": {
      "--vibe-color-hyperlink": "#1a0dab"
    }
  },
  "pet-policy-blurb.text": {
    "properties": {
      "--vibe-color-hyperlink": "#1a0dab"
    }
  },
  "propertyoverview.description": {
    "properties": {
      "--vibe-color-hyperlink": "#1a0dab"
    }
  },
  "resident-access-blurb.text": {
    "properties": {
      "--vibe-color-hyperlink": "#1a0dab"
    }
  },
  "schedule-tour-blurb.text": {
    "properties": {
      "--vibe-color-hyperlink": "#1a0dab"
    }
  },
  "virtual-tour-blurb.text": {
    "properties": {
      "--vibe-color-hyperlink": "#1a0dab"
    }
  }
};
